export default el => {
	const input = el.querySelector('.js-limit-characters-input');
	const count = el.querySelector('.js-limit-characters-count');
	const max = Number(el.dataset.limit);

	if (input && count && max) {
		input.addEventListener('input', (e) => {
			if (input.value.length > max) {
				return;
			}

			count.textContent = input.value.length;
		});
	}
};